export function toTitleCase(text: string) {
	return text.replace(/\b\w/g, (t) => t.charAt(0).toUpperCase() + t.substring(1))
}
